<template>
  <div class="my-info-browsinghistory">
    <div class="f-nav">
      <div :class="['nav', changeType == 'r' ? 'active-nav' : '']">
        <div class="nav-block" @click="change_type('r')">
          <div>二手</div>
          <div
            :class="[
              'nav',
              changeType == 'r' ? 'change-line-active' : 'change-line',
            ]"
          ></div>
        </div>
      </div>
      <div
        :class="['nav', changeType == 'z' ? 'active-nav' : '']"
        @click="change_type('z')"
      >
        <div class="nav-block">
          <div>租房</div>
          <div
            :class="[
              'nav',
              changeType == 'z' ? 'change-line-active' : 'change-line',
            ]"
          ></div>
        </div>
      </div>
      <div
        :class="['nav', changeType == 'x' ? 'active-nav' : '']"
        @click="change_type('x')"
      >
        <div class="nav-block">
          <div>新房</div>
          <div
            :class="[
              'nav',
              changeType == 'x' ? 'change-line-active' : 'change-line',
            ]"
          ></div>
        </div>
      </div>
    </div>

    <div>
      <div class="wrapper">
        <house-item
          v-for="(house, index) in list"
          :key="index"
          :house="house"
          type="2"
          @handleHosue="handleHosue"
        ></house-item>
      </div>
    </div>
    <div class="browse-menu" v-show="changeType == 'r' && show_selectedType">
      <div class="f-nav">
        <div :class="['nav', changeType == 'l' ? 'active-nav' : '']">
          <div class="nav-block" @click="change_type('l')">
            <div class="nav-block-arrow">
              <div>实地看房</div>
              <div class="arrow-bottom"></div>
            </div>
          </div>
        </div>
        <div
          :class="['nav', changeType == 's' ? 'active-nav' : '']"
          @click="change_type('s')"
        >
          <div class="nav-block">
            <div>VR看房</div>
          </div>
        </div>
      </div>
      <div class="change-type">
        <div
          :class="['tag', liu_selected == 'ershoufan' ? 'active-tag' : '']"
          @click="selectType('ershoufan')"
        >
          <div>全部</div>
          <div style="display: none" class="show-active-tag">
            <img
              class="selected-icon"
              src="../../images/icon/selected.png"
              alt=""
            />
          </div>
        </div>
        <div
          :class="['tag', liu_selected == 'zufan' ? 'active-tag' : '']"
          @click="selectType('zufan')"
        >
          <div>待看房</div>
          <div style="display: none" class="show-active-tag">
            <img
              class="selected-icon"
              src="../../images/icon/selected.png"
              alt=""
            />
          </div>
        </div>
        <div
          :class="['tag', liu_selected == 'xinfan' ? 'active-tag' : '']"
          @click="selectType('xinfan')"
        >
          <div>已看房</div>
          <div style="display: none" class="show-active-tag">
            <img
              class="selected-icon"
              src="../../images/icon/selected.png"
              alt=""
            />
          </div>
        </div>
        <div
          :class="['tag', liu_selected == 'xinfan' ? 'active-tag' : '']"
          @click="selectType('xinfan')"
        >
          <div>已取消</div>
          <div style="display: none" class="show-active-tag">
            <img
              class="selected-icon"
              src="../../images/icon/selected.png"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import actions from "../../common/test.js";
import util from "../../common/util.js";
import houseItem from "../../component/houseItem.vue";
export default {
  components: { houseItem },
  data() {
    return {
      list: [],
      changeType: "r",
      liu_selected: "ershoufan",
      show_selectedType: true,
    };
  },
  created() {
    this.$store.commit("changeTitle", "看房管理");
    util.hideLoading();
  },
  updated() {},
  computed: {},
  watch: {},
  mounted() {
    this.getlist();
  },
  methods: {
    getlist() {
      console.log("aaa");
      let data = {
        page_size: 10,
        page_number: 1,
        type: 2,
        is_system: "no",
        api_name: "infolist",
      };
      actions.getHouseList(data).then((res) => {
        if (res.is_success == 0) {
          this.list = res.content;
        }
      });
    },
    handleHosue(type, house) {
      if (type == "detail") {
        this.$router.push({
          name: "detail",
          params: { id: house.id, type: this.type },
          query: this.$route.query,
        });
      }
    },
    change_type(data) {
      this.changeType = data;
    },
    selectType(type) {
      this.liu_selected = type;
    },
  },
};
</script>

<style scoped lang="scss">
.my-info-browsinghistory {
  min-block-size: 100vh;
  background: #ffffff;
  .f-nav {
    height: 0.8rem;
    display: flex;
    justify-content: space-between;
    background: #ffffff;
    height: 1rem;
    .nav {
      width: 50%;
      font-size: 0.3rem;
      text-align: center;
      font-weight: 600;
      display: flex;
      align-items: center;
      .change-line {
        display: inline-block;
        width: 0.3rem;
        height: 0.06rem;
      }
      .change-line-active {
        display: inline-block;
        width: 0.3rem;
        height: 0.06rem;
        background-image: linear-gradient(to right, #f5e2b8, #edbd59);
        border-radius: 0.06rem;
      }
      .nav-block {
        margin: 0 auto;
      }
    }
    .active-nav {
      color: #ecb94c;
    }
  }
  .change-type {
    .tag {
      font-size: 0.24rem;
      height: 0.6rem;
      line-height: 0.6rem;
      padding: 0 0.5rem;
      background: #f8f8f8;
      display: inline-block;
      margin-left: 0.1rem;
    }
    .active-tag {
      background: #fbf2e1;
      color: #ecb94c;
    }
  }
  .search {
    position: relative;
    display: flex;
    align-items: center;
    height: 0.6rem;
    margin: 0.2rem 0.23rem;
    background-color: #e8e8e9;
    padding: 0 0 0 0.18rem;
    .search-input {
      flex: 1;
      background-color: #e8e8e9;
      padding-left: 0.2rem;
    }
    .search-btn {
      color: #fff;
      height: 0.6rem;
      line-height: 0.6rem;
      background-color: #ff725c;
      border-color: #ff725c;
      text-align: center;
      border-radius: 0.05rem;
      font-size: 0.2rem;
      padding: 0 0.3rem;
    }
  }
  .filter {
    position: relative;
    display: flex;
    height: 0.9rem;
    border-top: 1px solid #f2f2f2;
    border-bottom: 1px solid #f2f2f2;
    background-color: #fff;
    .filter-item {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #999;
      font-size: 0.24rem;
    }
    .filter-icon {
      margin-left: 0.1rem;
    }
  }

  .wrapper {
    border-bottom: 1px solid #f2f2f2;
    padding-left: 0.4rem;
    background-color: #fff;
  }
  .wrapper-null {
    font-size: 0.32rem;
    color: #999;
    line-height: 5em;
    text-align: center;
  }
  .loadmore-tip {
    font-size: 0.24rem;
    color: #999;
    line-height: 2em;
    text-align: center;
    background-color: #f5f5f5;
  }
  .browse-menu {
    position: fixed;
    top: 1rem;
    height: 100vh;
    width: 100%;
    background: rgba($color: #000000, $alpha: 0.5);
    .change-type {
      padding: 0.2rem 0.4rem;
      background: #ffffff;
      border-top: 1px solid #eeeeee;
      .tag {
        font-size: 0.3rem;
        height: 0.7rem;
        background: #ffffff;
        line-height: 0.6rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
      .active-tag {
        color: #ecb94c;
        .show-active-tag {
          display: block !important;
        }
      }
    }
  }
  .arrow-bottom {
    width: 0;
    height: 0;
    border-right: 0.1rem solid transparent;
    border-left: 0.1rem solid transparent;
    border-top: 0.1rem solid #ecb94c;
    display: block;
  }
  .nav-block-arrow {
    position: relative;
  }
  .arrow-bottom {
    position: absolute;
    top: 0.11rem;
    right: -0.3rem;
  }
  .selected-icon {
    width: 0.4rem;
  }
}
</style>

